import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

interface CoverageErrorRequest {
  type: string;
  startDate: Date;
  endDate: Date;
}

interface CoverageErrorMessageProps {
  coverageErrorRequests: CoverageErrorRequest[];
}

export const CoverageErrorMessage: React.FC<CoverageErrorMessageProps> = ({
  coverageErrorRequests,
}) => {
  const { t } = useTranslation();

  // If no specific requests, show generic error
  if (coverageErrorRequests.length === 0) {
    return <div>{t("MY_LEAVE_COVERAGE_ERROR")}</div>;
  }

  // Group by type
  const hoRequests = coverageErrorRequests.filter((req) => req.type === "O");
  const leaveRequests = coverageErrorRequests.filter((req) => req.type !== "O");

  return (
    <>
      {/* HomeOffice requests - show date ranges */}
      {hoRequests.length > 0 && (
        <div>
          {t("MY_LEAVE_COVERAGE_ERROR_HOME_OFFICE")}
          <span>
            {" "}(
            {hoRequests
              .map((req) => {
                const start = moment(req.startDate).format("MM.DD.");
                const end = moment(req.endDate).format("MM.DD.");
                return start === end ? start : `${start} - ${end}`;
              })
              .join(", ")}
            )
          </span>
        </div>
      )}
      {/* Leave requests - show date ranges */}
      {leaveRequests.length > 0 && (
        <div>
          {t("MY_LEAVE_COVERAGE_ERROR_LEAVE")}
          <span>
            {" "}(
            {leaveRequests
              .map((req) => {
                const start = moment(req.startDate).format("MM.DD.");
                const end = moment(req.endDate).format("MM.DD.");
                return start === end ? start : `${start} - ${end}`;
              })
              .join(", ")}
            )
          </span>
        </div>
      )}
    </>
  );
};
